
export const CONTEXT_INITIAL_STATE = {
    credentials: null,
    systemParams: null,
    systemConfig: null,
    systemConfigParameterValue: null,
    sectionsData: null,

    /* Mensagens de toast. */
    toastMessage: {
        type: 'normal', // 'error' , 'success'
        content: null,
    },

    /* context de vendas */
    saleRelease: null,
    saleCourseData: null,
    saleGuests: null,
    saleResponsible: null,
    saleBuyer: null,
    salePayment: null,

    /* EAD */
    eadRelease: null,
    eadAccount: null,
    eadAUser: null,


}



// WEBPACK FOOTER //
// ./src/constants.js